import React from 'react';
import { Link, useLocation } from 'react-router';
import { BookOpen, HeartHandshake, Home, Leaf, Settings, Sunrise } from 'lucide-react';
import UserMenu from './UserMenu';

const navigationItems = [
  {
    label: 'Home',
    to: '/',
    icon: Home,
    isActive: (pathname) => pathname === '/'
  },
  {
    label: 'Prayer',
    to: '/prayer',
    icon: HeartHandshake,
    isActive: (pathname) => pathname === '/prayer' || pathname === '/prayer/generate'
  },
  {
    label: 'Bible',
    to: '/bible/reader',
    icon: BookOpen,
    isActive: (pathname) => (
      pathname === '/bible'
      || pathname.startsWith('/bible/')
      || pathname === '/bible-reader'
      || pathname.startsWith('/bible-reader/')
      || pathname === '/read'
      || pathname.startsWith('/read/')
    )
  },
  {
    label: 'Devotional',
    to: '/devotionals',
    icon: Sunrise,
    isActive: (pathname) => (
      pathname === '/devotionals' || pathname.startsWith('/devotionals/')
    )
  }
];

const hiddenRoutePrefixes = ['/login', '/admin', '/intro'];

export default function PrimaryNavigation() {
  const { pathname } = useLocation();

  if (hiddenRoutePrefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))) {
    return null;
  }

  return (
    <header className="vd-app-nav-shell">
      <Link className="vd-primary-nav-brand" to="/" aria-label="Prayer Guide home">
        <Leaf size={25} aria-hidden="true" />
        <span>Prayer Guide</span>
      </Link>

      <nav className="vd-primary-nav" aria-label="Primary">
        {navigationItems.map(({ label, to, icon: Icon, isActive }) => {
          const active = isActive(pathname);

          return (
            <Link
              className={`vd-primary-nav-link${active ? ' is-active' : ''}`}
              to={to}
              aria-current={active ? 'page' : undefined}
              key={to}
            >
              <Icon size={19} aria-hidden="true" />
              <span>{label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="vd-primary-nav-account">
        <Link className="vd-surface-action" to="/settings" aria-label="Settings and optional delivery schedules">
          <Settings size={20} aria-hidden="true" />
        </Link>
        <UserMenu />
      </div>
    </header>
  );
}
